Vue.component('search-minimal', {
  template: '#vue-search-minimal',
  data: function () {
    return {
      params: {
        destination: config['components']['search-minimal']['destinationDefault'], // resetowane w "resetParams"
        city: '',
        adults: 2, // resetowane w "resetParams"
        childrens: 0, // resetowane w "resetParams"
        mw: 'default',
        days: '',
        start_date: '',
        start_date_api: '',
        end_date: '',
        end_date_api: '',
        extraCheckboxes: [],
        age_child_1: 'default',
        age_child_2: 'default',
        age_child_3: 'default',
        age_child_4: 'default'
      },
      config: {
        destinations: [],
        cities: [],
        adults: [],
        childrens: [],
        mw: [],
        days: [],
        extraCheckboxes: [],
        age_child_1: [],
        age_child_2: [],
        age_child_3: [],
        age_child_4: [],
        show: {
          mw: false,
          days: false,
          destination_city: false,
          age_child_1: false,
          age_child_2: false,
          age_child_3: false,
          age_child_4: false,
        }
      },
      tmp: {
        destinationsAndCities: []
      },
      vSliderItemClass: 'vSliderItemClass'
    }
  },
  computed: {
    backgrounds: function () {
      if (store.state.config.backgrounds !== undefined && store.state.config.backgrounds !== null && Object.keys(store.state.config.backgrounds)) {
        Object.keys(store.state.config.backgrounds).forEach(function (key) {
          let srcset = {};
          if (typeof store.state.config.backgrounds[key].url !== 'undefined' && store.state.config.backgrounds[key].url !== null && store.state.config.backgrounds[key].url !== '') {
            // srcset.s = store.state.config.backgrounds[key].url.replace(/\.([^\.]*)$/,'s.$1');
            // srcset.m = store.state.config.backgrounds[key].url.replace(/\.([^\.]*)$/,'m.$1');
            srcset.l = store.state.config.backgrounds[key].url.replace(/\.([^\.]*)$/, 'l.$1');
          }
          store.state.config.backgrounds[key].srcset = srcset;
        });
      }
      return store.state.config.backgrounds;
    }
  },
  created: function () {
    if (agentx != "kompas2www" || agentx == "kompasoasis2www") {
      setCanonicalTag('https://' + location.host + '/');
    }
    if (config['components']['search-minimal']['cityAs'] == 'select') {
      this.params.city = 'default';
    }
    this.refreshSearch();
    this.loadMeta();
  },
  watch: {
    'params.destination': function (newType, oldType) {
      if (oldType != '') {
        if (this.config.show['destination_city']) this.changeCities(newType);
      }
    },
    'params.childrens': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.showSelectAgeChildrens(newValue);
      }
    },
    'params.start_date': function (newValue, oldValue) {
      $("input#start_date").datepicker("update", newValue);
      if (newValue != this.params.start_date_api) {
        this.params.end_date = moment(newValue, "DD.MM.YYYY").add(1, 'days').format("DD.MM.YYYY");
      }
    },
    'params.end_date': function (newValue, oldValue) {
      $("input#end_date").datepicker("update", newValue);
    }
  },
  methods: {
    loadMeta: function () {
      const self = this;
      $.post("/back/Meta.php", { page: '/', type: 'static' }, function (result, textStatus) {
        if (result !== null) {
          if (result.title) setPageTitle(result.title);
          Object.keys(result.meta).forEach(function (key) {
            setMeta(key, result.meta[key]);
          });
        }
      }, "json");
    },
    refreshSearch: function () {
      const self = this;
      serverBus.$emit('loading_start');
      $.post("/back/search/SearchConfigMinimal.php", null, function (result, textStatus) {
        self.resetParams();
        if (typeof result.config === 'undefined') result.config = {};
        if (typeof result.config.show === 'undefined') result.config.show = {};

        // mw
        // if (typeof result.mw !== 'undefined') self.params.mw = result.mw; // to nie tak, bo "params" to wybrany, a nie wszystkie do wyboru
        if (typeof result.config.show['mw'] !== 'undefined' && result.config.show['mw'] && typeof result.mw !== 'undefined' && result.mw) {
          result.mw.forEach(function (e) { self.config.mw.push(e) });
          self.config.show['mw'] = (self.config.mw) ? result.config.show['mw'] : false;
        }

        // reszta
        if (typeof result.start_date !== 'undefined') {
          self.params.start_date_api = result.start_date;
          self.params.start_date = result.start_date;
        }
        if (typeof result.end_date !== 'undefined') {
          self.params.end_date_api = result.end_date;
          self.params.end_date = result.end_date;
        }
        if (typeof result.day !== 'undefined') self.params.days = result.day;

        if (typeof result.config.show['destination_city'] !== 'undefined') {
          self.config.show['destination_city'] = result.config.show['destination_city'];
        } else self.config.show['destination_city'] = true;

        if (typeof result.config.show['days'] !== 'undefined') {
          self.config.show['days'] = result.config.show['days'];
        } else self.config.show['days'] = true;

        self.tmp.destinationsAndCities = [];
        if (result.destination !== undefined && result.destination !== null) {
          for (let j = 0, len = result.destination.length; j < len; j++) {
            self.tmp.destinationsAndCities.push(result.destination[j]);
          }
          self.config.destinations = [];
          for (let j = 0, len = result.destination.length; j < len; j++) {
            self.config.destinations.push(result.destination[j]);
          }
          if (self.config.show['destination_city']) {
            self.config.destinations.sort(function (a, b) {
              return ('' + a.text).localeCompare(b.text);
            });
          }
        }

        self.config.adults = [];
        if (result.adults !== undefined && result.adults !== null) {
          for (let j = 0, len = result.adults.length; j < len; j++) {
            self.config.adults.push(result.adults[j]);
          }
        }

        self.config.childrens = [];
        if (result.childrens !== undefined && result.childrens !== null) {
          for (let j = 0, len = result.childrens.length; j < len; j++) {
            self.config.childrens.push(result.childrens[j]);
          }
        }

        self.config.days = [];
        for (let j = 0, len = result.days.length; j < len; j++) {
          self.config.days.push(result.days[j]);
        }

        self.config.extraCheckboxes = [];
        for (let j = 0, len = result.extra_checkboxes.length; j < len; j++) {

          // if (agentx == "kompas2www" || agentx == "kompasoasis2www") {
          //   if (result.extra_checkboxes[j].name == "Promocja") {
          //     result.extra_checkboxes[j].name = 'Wyróżnione oferty';
          //   }
          // }

          self.config.extraCheckboxes.push(result.extra_checkboxes[j]);
        }
        self.params.extraCheckboxes = [];
        for (let j = 0, len = result.extra_checkboxes_checked.length; j < len; j++) {
          self.params.extraCheckboxes.push(result.extra_checkboxes_checked[j]);
        }

        self.config.age_child_1 = [];
        if (result.age_child_1 !== undefined && result.age_child_1 !== null) {
          for (let j = 0, len = result.age_child_1.length; j < len; j++) {
            self.config.age_child_1.push(result.age_child_1[j]);
          }
        }

        self.config.age_child_2 = [];
        if (result.age_child_2 !== undefined && result.age_child_2 !== null) {
          for (let j = 0, len = result.age_child_2.length; j < len; j++) {
            self.config.age_child_2.push(result.age_child_2[j]);
          }
        }

        self.config.age_child_3 = [];
        if (result.age_child_3 !== undefined && result.age_child_3 !== null) {
          for (let j = 0, len = result.age_child_3.length; j < len; j++) {
            self.config.age_child_3.push(result.age_child_3[j]);
          }
        }

        self.config.age_child_4 = [];
        if (result.age_child_4 !== undefined && result.age_child_4 !== null) {
          for (let j = 0, len = result.age_child_4.length; j < len; j++) {
            self.config.age_child_4.push(result.age_child_4[j]);
          }
        }

        if (self.config.show['destination_city']) self.changeCities('default');
        serverBus.$emit('loading_end');
      }, "json");
    },
    changeCities: function (destination) {
      const self = this;
      self.config.cities = [];
      for (let j = 0, len = self.tmp.destinationsAndCities.length; j < len; j++) {
        if (self.tmp.destinationsAndCities[j].value == destination || destination == 'default') {
          for (let i = 0, len2 = self.tmp.destinationsAndCities[j].cities.length; i < len2; i++) {
            if (config['components']['search-minimal']['cityAs'] == 'select') {
              self.config.cities.push(self.tmp.destinationsAndCities[j].cities[i]);
            } else {
              self.config.cities.push(self.tmp.destinationsAndCities[j].cities[i].value);
            }
          }
        }
      }
      self.config.cities.sort(function (a, b) {
        return ('' + a.text).localeCompare(b.text);
      });
    },
    clickSearch: function () {
      this.searchOffers(this.params)
    },
    searchOffers: function (params) {
      let query = {
        destination: params.destination,
        city: params.city,
        adults: params.adults,
        childrens: params.childrens,
        days: params.days,
        start_date: params.start_date,
        end_date: params.end_date,
        age_child_1: params.age_child_1,
        age_child_2: params.age_child_2,
        age_child_3: params.age_child_3,
        age_child_4: params.age_child_4
      };
      if (params.mw && params.mw !== 'default') {
        query.mw = params.mw;
      }
      if ($.inArray("ai", this.params.extraCheckboxes) != -1) {
        query.alimentation = "ALL";
      }
      if ($.inArray("fm", this.params.extraCheckboxes) != -1) {
        query.discount = "fm";
      }
      if ($.inArray("lm", this.params.extraCheckboxes) != -1) {
        query.discount = "lm";
      }
      if ($.inArray("po", this.params.extraCheckboxes) != -1) {
        query.discount = "po";
      }

      // wywalanie "default"
      Object.keys(query).forEach(function (key) {
        if (query[key] === 'default' || !query[key]) {
          delete query[key];
        }
      });

      firstLoad = true;

      router.push({
        name: 'search',
        query: query
      });
    },
    resetParams: function () {
      const self = this;
      self.params.destination = config['components']['search-minimal']['destinationDefault'];
      self.params.adults = 2;
      self.params.childrens = 0;
    },
    showSelectAgeChildrens: function (how_much) {
      const self = this;

      for (let i = 1; i <= 4; i++) {
        if (how_much >= i) {
          self.config.show['age_child_' + i] = true;

        } else {
          self.config.show['age_child_' + i] = false;
          self.params['age_child_' + i] = '';

        }
      }
    }
  },
  mounted: function () {
    const self = this;
    self.$nextTick(function () {
      $('.input-daterange').datepicker({
        format: "dd.mm.yyyy",
        language: lang,
        autoclose: true,
        startDate: "dateToday"
      }).on('changeDate', function (e) {
        self.params[e.target.id] = e.target.value;
      });;
    })
  }
});

function convertDate(inputFormat) {
  function pad(s) {
    return (s < 10) ? '0' + s : s;
  }
  let d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('.');
}

Vue.component('slider-content', {
  template: '#vue-slider-content',
  props: ['background']
});
